













































import { editFactory } from '@/main/pages';
import { PageMode } from '@/main/utils/pageMode';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import _ from 'lodash';
import { WCas } from '@/modules/ciselnik/dilenske/wCas';
import { Zakazka } from '@/modules/servis/zakazka';

import { SNIMANIE_CASU, depTableNames } from './constants';
import { store } from './store/snimani';
import { apiProvider } from './api';

export default editFactory(SNIMANIE_CASU, store).extend({
	data() {
		return {
			dependencies: depTableNames,
			interval: null as any,
			intervalCountDown: null as number | null,
			intervalText: null as string | null,
			disableDeleteLast: true,
		};
	},
	computed: {
		pageMode(): PageMode {
			return PageMode.CREATE;
		},
	},
	watch: {
		async CaswId() {
			await this.insertCasovuUdalost();
		},
		async ZakazkaId() {
			await this.insertCasovuUdalost();
		},
		async PracovnikId() {
			await this.insertCasovuUdalost();
		},
	},
	methods: {
		async insertCasovuUdalost() {
			if (this.PracovnikId && (this.ZakazkaId || this.CaswId)) {
				this.startLoading();
				this.ZacatekDat = new Date();
				const casovaUdalost = { PracovnikId: this.PracovnikId, CaswId: this.CaswId, ZakazkaId: this.ZakazkaId };
				await apiProvider.recordTime(casovaUdalost);
				this.disableDeleteLast = false;
				this.refreshTable();
				this.endLoading();
			}
		},
		default() {
			// Default sa nepouziva
		},
		nulovat() {
			this.deleteBarcode();
			this.Barcode = null;
			this.interval && clearInterval(this.interval);
		},
		async deleteLastTime() {
			this.disableDeleteLast = true;
			await apiProvider.deleteLast(this.PracovnikId!);
			this.refreshTable();
		},
		async submit() {
			if (this.Barcode?.startsWith('P-')) {
				await this.loadPracovnik();
			} else if (this.Barcode?.startsWith('W-')) {
				await this.loadWCas();
			} else {
				await this.loadZakazku();
			}
		},
		async loadZakazku() {
			const { data } = await Zakazka.apiProvider.getZakazkaByNr(parseInt(this.Barcode!, 10));
			this.Barcode = null;
			this.ZakazkaId = data?.ZakazkaId;
			this.ZakazkaNrText = data?.ZakazkaNrText;
			this.startBarcodeDeleteTimer();
		},
		async loadWCas() {
			const { data } = await WCas.apiProvider.getCasWByOzn(this.Barcode?.replace('-', '')!);
			this.Barcode = null;
			this.CaswOzn = data?.CaswOzn;
			this.CaswText = data?.Text;
			this.CaswId = data?.CaswId;
			this.CaswPznText = data?.CaswPznText;
			this.startBarcodeDeleteTimer();
		},
		async loadPracovnik() {
			const { data } = await Pracovnik.apiProvider.getPracovnikByPersonCard(parseInt(this.Barcode?.slice(2)!, 10));
			this.Barcode = null;
			this.OsobniCislo = data?.OsobniCis;
			this.PracovnikId = data?.PracovnikId;
			this.Jmeno = data?.PracovnikText;
			this.startBarcodeDeleteTimer();
			this.refreshTable();
		},
		startBarcodeDeleteTimer() {
			if (this.Rucne) return;
			this.intervalCountDown = Number(this.loggedUser.DmsSys.BarcodeMazat);
			this.interval && clearInterval(this.interval);
			this.interval = setInterval(() => {
				if (_.isNil(this.intervalCountDown) || this.intervalCountDown < 0) {
					clearInterval(this.interval);
					this.deleteBarcode();
				} else {
					this.intervalText = (this.Localize('CU_nulovat') as string).replace('%d', this.intervalCountDown.toString());
					this.intervalCountDown! -= 1;
				}
			}, 1000);
		},
		deleteBarcode() {
			this.CaswId = null;
			this.CaswText = null;
			this.CaswOzn = null;
			this.CaswPznText = null;
			this.PracovnikId = null;
			this.OsobniCislo = null;
			this.Jmeno = null;
			this.ZakazkaId = null;
			this.ZakazkaNrText = null;
			this.ZakazkaNr = null;
			this.ZacatekDat = null;
			this.dependentTables.EscDnes.rows = [];
			this.disableDeleteLast = true;
		},
		async refreshTable() {
			await this.fetchTableData();
			(this.$refs.table as any).refreshLayout();
		},
	},
});
